import BlockTypes from '../../../types/BlockTypes';
import isActiveBlock from '../queries/isActiveBlock';
export default function toggleBlock(editor, blockType) {
  var defaultType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BlockTypes.UNSTYLED;
  return isActiveBlock(editor, blockType) ? editor.setBlocks(defaultType) : editor.setBlocks(blockType);
}